import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";

const DialogBox = (props) => {
  const {sweetAlertProps, children} = props;
  return (
    <>
      <SweetAlert
       {...sweetAlertProps}
      >
        {children}
      </SweetAlert>
    </>
  );
};

export default DialogBox;


